import { render, staticRenderFns } from "./liveness_landingPage.vue?vue&type=template&id=356407a2&scoped=true"
import script from "./liveness_landingPage.vue?vue&type=script&lang=js"
export * from "./liveness_landingPage.vue?vue&type=script&lang=js"
import style0 from "./liveness_landingPage.vue?vue&type=style&index=0&id=356407a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356407a2",
  null
  
)

export default component.exports